export default __webpack_public_path__ + "static/media/003-bread.73a96088.svg";